class FooterAccordion extends HTMLElement {
  constructor() {
    super();

    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    this.summaryIsEmpty = this.summaryToggle.textContent.trim().length == 0;

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    // Keep all footer groups compact on both desktop and mobile.

    if (this.summaryIsEmpty) {
      this.detailsContainer.setAttribute('open', true);

      if (this.summaryIsEmpty) {
        this.detailsContainer.setAttribute('empty', true);
      }
    }
    else {
      this.detailsContainer.removeAttribute('open');
      this.summaryToggle.removeAttribute('tabindex');
      this.summaryToggle.setAttribute('role','button');
      this.summaryToggle.setAttribute('aria-expanded','false');
    }
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open')
      ? this.close()
      : this.open();
  }

  open() {
    this.detailsContainer.setAttribute('open', true);
    this.summaryToggle.setAttribute('aria-expanded','true');
  }

  close() {
    if (!this.summaryIsEmpty) {
      this.detailsContainer.removeAttribute('open');
      this.summaryToggle.setAttribute('aria-expanded','false');
    }
  }
}

customElements.define('footer-accordion', FooterAccordion);